import http from './httpService';
import config from '../configs/config.js';
import { largeDate } from '../utils/constants';

const apiEndPoint = config.apiEndPoint + '/mail';
const commentsEndPoint = config.apiEndPoint + '/comments';
const feedbackEndPoint = config.apiEndPoint + '/feedback';

//Email API
export async function sendMail(mail) {
  let query = apiEndPoint;
  let data = await http.get(query, {
    params: {
      email: mail.email,
      first_name: mail.first_name,
      last_name: mail.last_name,
      subject: mail.subject,
      message: mail.message
    }
  });
  return data;
}

//Comments API
export async function getComments(id) {
  let comments = await http.get(commentsEndPoint + '/' + id);
  comments.data.forEach(function (data, i) {
    let last_upd = new Date(data.last_updated + 'Z');
    data.last_updated = last_upd.toLocaleString(undefined, largeDate);
    let crt_date = new Date(data.created_date + 'Z');
    data.created_date = crt_date.toLocaleString(undefined, largeDate);
  });
  //console.log('Comments API', comments);
  return comments;
}

//Insert Comments API
export async function insertComment(comment, anomaly_id, type) {
  let body = {
    anomaly_id: anomaly_id,
    comment: comment,
    type: type || 'alert'
  };
  let result = await http.post(commentsEndPoint, body);
  let last_upd = new Date(result.data.last_updated + 'Z');
  result.data.last_updated = last_upd.toLocaleString(undefined, largeDate);
  let crt_date = new Date(result.data.created_date + 'Z');
  result.data.created_date = crt_date.toLocaleString(undefined, largeDate);
  //console.log('Comment Entry API', result);
  return result;
}

//Insert Comments API
export async function updateComment(comment, commentid) {
  let body = {
    comment: comment
  };
  let result = await http.put(commentsEndPoint + '/' + commentid, '', {
    params: body
  });
  //console.log('Comment Update API', result);
  return result;
}

//Delete Comments API
export async function deleteComment(commentid) {
  let result = await http.delete(commentsEndPoint + '/' + commentid);
  //console.log('Comment Delete API', result);
  return result;
}

//Insert Feedback API
export async function insertFeedback(alert, type) {
  let body = {
    anomaly_id: alert.anomaly_id,
    rca_id: type === 'rca' ? alert.rca_id : '',
    liked: alert.liked,
    feedback_for: type
  };
  let result = await http.post(feedbackEndPoint, body);
  //console.log('Feedback Entry API', result);
  return result;
}

//Update Feedback API
export async function updateFeedback(alert) {
  let rca = !Object.keys(alert).includes('question4');
  let body = {
    liked: alert.liked,
    question1: alert.question1,
    question1_comment: alert.question1_comment,
    question2: alert.question2,
    question2_comment: alert.question2_comment,
    question3: alert.question3,
    question3_comment: alert.question3_comment,
    question4: rca ? null : alert.question4,
    question4_comment: rca ? null : alert.question4_comment
  };
  let result = await http.put(feedbackEndPoint + '/' + alert.feedbackid, body);
  //console.log('Feedback Update API', result);
  return result;
}

//Feedback API
export async function feedbackAction(alert, type) {
  let keys =
    Object.keys(alert).includes('feedbackid') &&
    alert.feedbackid !== null &&
    alert.feedbackid;
  let result = {};
  if (keys) result = updateFeedback(alert);
  else result = insertFeedback(alert, type);
  return result;
}
